import {
  DocumentSearchParameter,
  SearchConditionPresetKinds,
} from "./";

export class DocumentSearchPresetCondition {
  key: string;
  name: string;
  condition: DocumentSearchParameter;
  presetKind: SearchConditionPresetKinds;
  index: number;
  departmentId: string;
  isDefaultSelected: boolean;

  constructor() {
    this.key = "";
    this.name = "";
    this.condition = new DocumentSearchParameter();
    this.presetKind = SearchConditionPresetKinds.Person;
    this.index = null;
    this.departmentId = "";
    this.isDefaultSelected = false;
  }

  clone(): DocumentSearchPresetCondition {
    const newObj = new DocumentSearchPresetCondition();
    newObj.key = this.key;
    newObj.name = this.name;
    newObj.condition = this.condition.clone();
    newObj.presetKind = this.presetKind;
    newObj.index = this.index;
    newObj.departmentId = this.departmentId;
    newObj.isDefaultSelected = this.isDefaultSelected;
    return newObj;
  }
}
